import React, { useState, useCallback, useMemo } from 'react';
import { PCCardAction } from '../../../components/Common';
import { DuplicateList } from '../../../api/dto';
import { useLazyQuery } from '@apollo/client';
import { ParameterGraphQLService } from '../../../graphql/ParameterGraphQLService';
import { PCDataTable, PCDataTableResultPage } from '../../../components/DataTable/PCDataTable';
import { useRole } from '../../../hooks';
import { TableError } from '../../../components/DataTable';

interface ParameterDuplicateListProps {
  duplicates: DuplicateList;
}

/**
 * @author Jungwirth
 */
export const ParameterDuplicateList: React.FC<ParameterDuplicateListProps> = (props: Readonly<ParameterDuplicateListProps>): JSX.Element | null => {
  const { duplicates } = props;
  const [ result, setResult] = useState<PCDataTableResultPage<any>>({ data: [], page: { totalElements: 0, totalPages: 0} });
  const role = useRole();


  const [ loadDuplicates, { error, data, loading } ] = useLazyQuery(
    ParameterGraphQLService.getParameterList(), {
      fetchPolicy: 'network-only',
      onCompleted: () => {
        console.log('data', data);
        setResult({ data: data[Object.keys(data)[0]].data, page: { ...data[Object.keys(data)[0]].page }})
      }
    }
  );

  const fetchData = useCallback(async ({pageSize, pageIndex}) => {
    if(duplicates.length === 0) {
      return null;
    }
    loadDuplicates(
      {
        variables: {
          number: (pageIndex+1),
          size: pageSize,
          filter: ParameterGraphQLService.getFilterDuplicates(duplicates.map(e => e.code))
        }
      }
    )
  },[duplicates, loadDuplicates]);


  const columns = useMemo(
    () => {
      return ParameterGraphQLService.getColumns(role, true);
    }, [role]);

  return (
    <PCCardAction
      id="duplicates"
    >
      {error && duplicates.length !== 0 ?
        <TableError />
        :
        <React.Fragment>
          <PCDataTable
            columns={columns}
            data={result.data}
            loading={loading}
            fetchData={fetchData}
            pageInfo={result.page}
            serverMode
            multisort
            small
          />
        </React.Fragment>
      }
    </PCCardAction>
  );
};
